export default __webpack_public_path__ + "static/media/cards4.5bfc10b9.png";